module.exports = __webpack_public_path__ + "img/pic-slider-4.091ddb3.webp";